import { useEffect, useState } from "react";
import { Platform } from "react-native";

// sets the channel in db to either web or app based on the platform
export const useDetermineChannel = () => {
  const [channel, setChannel] = useState("APP");
  useEffect(() => {
    if (Platform.OS === "web") {
      setChannel("WEB");
    }
  }, []);
  return [channel];
};
